import { useGetStarted } from "hooks";
import { GetStartedStoreTypes } from "interfaces";
import { FC, useEffect, useState } from "react";
import { SubmitHandler } from "react-hook-form";

import EssentialPackage from "./EssentialPackage";
import FullService from "./FullServicePackage";

interface IProps {
  formId: string;
  store: GetStartedStoreTypes;
  onSubmit: SubmitHandler<GetStartedStoreTypes>;
  upgradeToFullService?: () => void;
  startOver?: () => void;
}

const serviceSteps = {
  "1": EssentialPackage,
  "2": FullService
};

const Summary: FC<IProps> = props => {
  const [currentStep, setCurrentStep] = useState(1);

  const { fullServiceRequired } = useGetStarted();

  const upgradeToFullService = () => {
    setCurrentStep(2);
  };

  const goBackToEssentialPackage = () => {
    setCurrentStep(1);
  };
  const CurrentService = serviceSteps[String(currentStep) as keyof typeof serviceSteps];

  const _props = {
    ...props,
    upgradeToFullService,
    goBackToEssentialPackage
  };

  useEffect(() => {
    if (props.store.package === "full") {
      upgradeToFullService();
    } else if (props.store.package === "essential") {
      goBackToEssentialPackage();
    } else if (fullServiceRequired(props.store) || props.store.relationship.bfa_exists === "yes") {
      upgradeToFullService();
    } else {
      goBackToEssentialPackage();
    }
  }, [props.store]);
  return <CurrentService {..._props} />;
};

export default Summary;
